import React from "react";
const RideSummary = ({
  pickupDate,
  pickupTime,
  pickup,
  destination,
  distDurationValue,
  tripType,
}) => {
  const formatPickupDate = (dateString) => {
    // Create a Date object from the given date string
    const date = new Date(dateString);

    // Format the date using toLocaleDateString
    const options = {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
    };
    const formattedDate = date.toLocaleDateString("en-US", options);

    return formattedDate;
  };
  const removeUAE = (address) => {
    const uae = "- United Arab Emirates";

    // Check if the address ends with "United Arab Emirates" and remove it
    if (address && address.endsWith(uae)) {
      // Remove " - United Arab Emirates" if it exists at the end
      return address.slice(0, -uae.length).trim();
    }
    // Return the address unchanged if "United Arab Emirates" isn't at the end
    return address;
  };
  return (
    <div className="ride_summery">
      <div className="Ride_dateTime">
        {formatPickupDate(pickupDate) + " at " + pickupTime + " (GST)"}
      </div>
      <div className="ride_pickupdropoff">
        <div className="pickupDropoffText pickup">{removeUAE(pickup)}</div>
        {tripType === "singleTrip" && (
          <>
            <div style={{ padding: "0 3px" }}>
              <svg
                role="img"
                className="arrow_icon"
                width="25"
                height="20"
                fill="currentColor"
                viewBox="0 0 24 24"
                style={{ verticalAlign: "top" }}
              >
                <path d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z" />
              </svg>
            </div>
            <div className="pickupDropoffText destination">
              {removeUAE(destination)}
            </div>
          </>
        )}
        {/* <div style={{ padding: "0 3px" }}>
          <svg
            role="img"
            className="arrow_icon"
            width="25"
            height="20"
            fill="currentColor"
            viewBox="0 0 24 24"
            style={{ verticalAlign: "top" }}
          >
            <path d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z" />
          </svg>
        </div>
        <div className="pickupDropoffText destination">
          {removeUAE(destination)}
        </div> */}
      </div>
      <div className="ride_duration">
        <span className="ride_distance">{distDurationValue}</span>
      </div>
    </div>
  );
};
export default RideSummary;
